@if (dTypeForm) {
  <div class="flex flex-col -m-6">
    <!-- Header -->
    <div
      class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
      <div class="text-lg font-medium">{{ $safeNavigationMigration(dTypeForm.dType?.caption) | localize }}</div>
      <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
        <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
      </button>
    </div>
    <!-- Content -->
    <div class="flex flex-col sm:flex-row items-center p-2 sm:p-8 sm:items-start w-full">
      @if (dTypeForm) {
        <div class="flex flex-row flex-auto flex-wrap w-full">
          @for (column of dTypeForm.dType?.column; track column) {
            @if (dTypeForm.fields[column.name]; as field) {
              @if (!field.hidden) {
                @if (field.browserOpts?.newLine) {
                  <div class="w-full"></div>
                }
                        <dtype-item [ngClass]="{
                                'w-full': field.browserOpts?.width === 'FULL' && field.type !== twoColumnsTable,
                                'w-1/2': field.browserOpts?.width === 'HALF' || (column.name === 'replyForm'),
                                'w-1/3': field.browserOpts?.width === 'THIRD',
                                'w-2/3': field.browserOpts?.width === 'TWO_THIRDS',
                                'w-1/4': field.browserOpts?.width === 'FOURTH',
                                'w-3/4': field.browserOpts?.width === 'THREE_FOURTHS',
                                'w-1/5': field.browserOpts?.width === 'FIFTH',
                                'w-2/5': field.browserOpts?.width === 'TWO_FIFTH',
                                'w-3/5': field.browserOpts?.width === 'THREE_FIFTHS',
                                'w-4/5': field.browserOpts?.width === 'FOUR_FIFTHS',
                                'w-1/6': field.browserOpts?.width === 'SIXTH',
                                'w-5/6': field.browserOpts?.width === 'FIVE_SIXTHS',
                                'px-2 py-2': !field.hidden && field.type !== embeddedItemUri && field.type !== embeddedItemCollectionUri
                            }" [field]="field" [isUpdate]="isUpdate"></dtype-item>
                @if (column.name === 'replyForm') {
                  <div animate.enter="fade-in" class="flex flex-col w-1/2 p-2">
                    <mat-form-field class="w-full">
                      <mat-label>{{ 'workdayVisibility' | transloco }}</mat-label>
                      <mat-select [(ngModel)]="item.visibleWorkDayTypeId" multiple [disabled]="!data.taskType.workDayTypeUri || !workdayOptions?.length">
                        @for (opt of workdayOptions; track opt) {
                          <mat-option [value]="opt.code" [disabled]="opt.disabled || opt._deprecated">
                            {{ opt.value | localize }}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-hint>
                        @if (data.taskType.workDayTypeUri && workdayOptions.length > 0) {
                          {{ 'workdayVisibilityHint' | transloco }}
                        }
                        @if (!data.taskType.workDayTypeUri || !workdayOptions?.length) {
                          {{ 'workdayMissingInTasktypeHint' | transloco }}
                        }
                      </mat-hint>
                    </mat-form-field>
                  </div>
                }
              }
            }
          }
        </div>
      }
    </div>
    <!-- Actions -->
    <div class="flex flex-col sm:flex-row justify-end gap-2 px-4 pb-2 sm:px-8 sm:pb-8 w-full">
      <button (click)="closeDialog()" mat-stroked-button>
        {{ 'cancel' | transloco }}
      </button>
      <button (click)="save()" mat-flat-button color="primary">
        {{ 'save' | transloco }}
      </button>
    </div>
  </div>
} @else {
  <div>no dTypeForm</div>
}

<!-- TODO add styles -->
